import { clsx } from "@trydig/ui";
import { forwardRef } from "react";
import styles from "./Table.module.css";

export const Table = forwardRef<HTMLTableElement, React.ComponentProps<"table">>(
	({ className, children, ...props }, ref) => {
		return (
			<table ref={ref} className={clsx(className, styles.table)} {...props}>
				{children}
			</table>
		);
	},
);
